import {mode$} from '@px/streams/spot';
import {activeOrders$ as spotActiveOrders$, activeOrderCount$ as spotActiveOrderCount$} from '@px/streams-spot/order-active';
import {activeOrders$ as marginActiveOrders$, activeOrderCount$ as marginActiveOrderCount$} from '@px/streams-margin/order-active';
import {SPOT_TRADE_MODE} from './enum';
import {createSpotModeState$} from './utils';

export const [activeOrders$] = createSpotModeState$<SpotPairActiveOrders>(
  mode$,
  {
    [SPOT_TRADE_MODE.Margin]: marginActiveOrders$,
    [SPOT_TRADE_MODE.Spot]: spotActiveOrders$,
  },
  []
);

export const [activeOrderCount$] = createSpotModeState$<string>(
  mode$,
  {
    [SPOT_TRADE_MODE.Margin]: marginActiveOrderCount$,
    [SPOT_TRADE_MODE.Spot]: spotActiveOrderCount$,
  },
  ''
);
